import type { IOption } from 'common/interfaces/IOption'
import type { IEmrProvider, IEmrProvidersResponse } from 'features/Patients/interfaces/IPatient'

// The option value must be emr_provider_id, never id: `id` is the Residen user
// id and `emr_provider_id` is the same person on the EMR side, and the patient
// payload's doctor_emr_id expects the latter. Picking the wrong one still
// yields a valid-looking number, so nothing would surface the mistake.
export const toEmrProviderOptions = (response: IEmrProvidersResponse): IOption<number>[] =>
  (response?.data ?? []).map(({ name, emr_provider_id }) => ({
    name,
    code: emr_provider_id,
  }))

export const getEmrLinkedResidenUserIds = (providers: IEmrProvider[]): Set<number> =>
  new Set(providers.filter((provider) => provider.emr_provider_id).map((provider) => provider.id))
